import React from "react";
import CurrentPlanCard from "../components/CurrentPlanCard";

const GroupCurrentPlan: React.FC = () => {
  return <CurrentPlanCard />;
};
export default GroupCurrentPlan;
